import script from "./PlayRecords.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayRecords.vue?vue&type=script&setup=true&lang=js"

import "./PlayRecords.vue?vue&type=style&index=0&id=827b02f8&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-827b02f8"]])

export default __exports__